import { render, staticRenderFns } from "./SiteAbout2.vue?vue&type=template&id=ccaed8d8&scoped=true"
var script = {}
import style0 from "./SiteAbout2.vue?vue&type=style&index=0&id=ccaed8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaed8d8",
  null
  
)

export default component.exports